import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Observable, Subject } from "rxjs";

@Injectable()
export class DataService_viewvisitordetail {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Wire Up Selected Event
	//
	//-----------------------------------------------------------------------------------------------------

	private VisitorLogSelectedSubject = new Subject<any>();

	VisitorLogSelected(VisitorLogID: number) {
		this.VisitorLogSelectedSubject.next(VisitorLogID);
	}

	onVisitorLogSelected(): Observable<any> {
		return this.VisitorLogSelectedSubject.asObservable();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorLogDetailGet
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorLogDetailGet(VisitorLogID: number) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorLogDetailGet";

		var promise$ = this.httpclientService.post(url, VisitorLogID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
